/**
 * GeneratedReportsCtrl controller
 * Generated reports list
 */

import {
  REPORT_TYPES,
  REPORT_STATUSES,
  SUBSCRIBERS_REPORT_TYPES,
  USERS_REPORT_TYPES,
  PAYMENT_SYSTEM_TYPES,
  REPORT_FINANCIAL_PERIODS, REPORT_FINANCIAL_PRODUCT_TYPES, PURCHASE_STATUSES_FOR_FINANCIAL_REPORT
} from 'app/core/constants'

/**
 * GeneratedReportsCtrl controller
 *
 * @class GeneratedReportsCtrl
 * @memberof mwApp/reports
 * @see mwApp/reports
 *
 * @ngdoc controller
 * @name mwApp/reports.controller:GeneratedReportsCtrl
 */
/* @ngInject */
export default function GeneratedReportsCtrl ($scope, $window, $timeout, Report, ReportStream, ReportFinancial, ReportTransaction, ReportSubscribers, ReportUsers, ReportSubscribersActivity, commonData, scope) {
  var vm = this

  vm.report_financial_periods = REPORT_FINANCIAL_PERIODS
  vm.report_financial_product_types = REPORT_FINANCIAL_PRODUCT_TYPES
  vm.purchase_item_statuses = PURCHASE_STATUSES_FOR_FINANCIAL_REPORT
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  let ReportModel = Report
  switch (scope.reportType) {
    case 'stream':
      ReportModel = ReportStream
      vm.report_types = REPORT_TYPES
      break
    case 'subscribers':
      ReportModel = ReportSubscribers
      vm.report_types = SUBSCRIBERS_REPORT_TYPES
      break
    case 'subscribers_activity':
      ReportModel = ReportSubscribersActivity
      break
    case 'users':
      ReportModel = ReportUsers
      vm.report_types = USERS_REPORT_TYPES
      break
    case 'financial':
      ReportModel = ReportFinancial
      break
    case 'transaction':
      ReportModel = ReportTransaction
      break
    default: break
  }

  vm.timerId = 0

  /**
   * Listen tab event
   */
  $scope.$on('dispatch: generated_reports', function () {
    $scope.$broadcast('refreshTable')
  })

  /**
   * isFound Flag
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {Boolean}
   */
  vm.isFound = true

  /**
   * Report statuses
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {Object}
   */
  vm.report_statuses = REPORT_STATUSES

  /**
   * Payment types
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Reports list
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {models.Report[]}
   */
  vm.templates = []

  /**
   * Module data
   *
   * @type {Object}
   */
  vm.commonData = commonData.data

  /**
   * Get list of reports from backend
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getReports = function (tableState) {
    // set default sort by id
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'id'
      tableState.sort.reverse = true
    }
    if (tableState.pagination.number === 0) {
      tableState.pagination.number = 25
    }

    if (scope.reportType === 'financial' || scope.reportType === 'transaction') {
      tableState.mappingParams = {}
      tableState.mappingParams.organizationName = 'organization-name'
    }

    ReportModel.loadSmart(tableState)
      .then(data => {
        vm.reports = data.content
        vm.isFound = !!vm.reports.length
        vm.pendingTimer = vm.reports.find((report) => !report.deleted && (report.reportStatus === 'PENDING' || report.status === 'CREATING')) ? 5000 : 0
        if (vm.timerId !== null && vm.pendingTimer !== 0) {
          vm.timerId = setTimeout(() => {
            $scope.$broadcast('refreshTable')
          }, vm.pendingTimer)
        }
      })
      .then(() => setTimeout(() => commonData.data.update('lastReport'), 7000))
  }

  /**
   * Export file by type
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @param {String} type
   * @param {models.Report} report
   */
  vm.export = function (type, report) {
    report._export(type)

    commonData.data.update('lastReport')
  }

  /**
   * Download report file
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @param {String} type
   * @param {models.Report} report
   * @param {Boolean} exprt
   */
  vm.download = function (type, report, exprt = false) {
    report._download(type, exprt)
    commonData.data.update('lastReport')
  }

  /**
   * Delete report
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @param {models.Report} report
   */
  vm.delete = function (report) {
    report._delete()
      .then(() => $scope.$broadcast('refreshTable'))
    commonData.data.update('lastReport')
  }

  $scope.$on('$destroy', () => {
    clearTimeout(vm.timerId)
    vm.timerId = null
  })
}
